import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CalendarViewOffices } from '../types';
import { MultiOfficeSectionWrapper } from './multi-office-section-wrapper';
import { OfficeProviders } from './office-providers';

type MultiOfficeProviders = {
  multiOfficeProviders: CalendarViewOffices;
  gridTemplateColumns: string;
};

export const MultiOfficeProviders = ({ multiOfficeProviders, gridTemplateColumns }: MultiOfficeProviders) => {
  const locationCount = multiOfficeProviders?.length ?? 0;
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: ${gridTemplateColumns};
        grid-template-rows: auto;
        flex: 1;
        gap: ${theme.spacing(2)};
      `}
    >
      {!!multiOfficeProviders &&
        multiOfficeProviders?.map((provider, index) => {
          if (provider?.providers?.length === 0) return; // Do not show column if no providers

          return (
            <section
              key={`${provider.officeName}-${index}`}
              css={css`
                display: flex;
                flex: 1;
                position: relative;
                transition: height 0.3s ease;
                align-items: flex-start;
                gap: ${theme.spacing(2)};
                ${index !== 0 &&
                `::after {
                    content: '';
                    position: absolute;
                    width: 2px;
                    height: 60px;
                    background: ${theme.colors.neutral5};
                    top: ${theme.spacing(1)};
                    left: -10px;
                  }`};
              `}
            >
              <MultiOfficeSectionWrapper
                officeName={provider.officeName}
                officeTimezone={provider.officeTimezone}
                providerCount={provider?.providers?.length ?? 0}
                showLocationHeader={locationCount > 1}
              >
                <OfficeProviders
                  providersData={provider?.providers.map((p) => ({
                    name: p.name,
                    src: p.src,
                    eventCount: p.events.filter((e) => e.type !== 'unavailable').length ?? 0,
                    providerId: p.providerId,
                    locationId: provider.locationId,
                    archived: p.archived,
                  }))}
                />
              </MultiOfficeSectionWrapper>
            </section>
          );
        })}
    </div>
  );
};
